import React from 'react';
import { Link } from 'react-router-dom';
import {
  CheckCircle2,
  Cloud,
  CloudOff,
  Lock,
  RefreshCw,
  Shield,
  Smartphone,
  Users,
} from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const benefitIcons = {
  cloud: Cloud,
  sync: RefreshCw,
  security: Shield,
  multi: Users,
  access: Smartphone,
  backup: Lock,
};

export default function PlusPage() {
  const { t } = useLanguage();
  const p = t.plusPage;

  return (
    <section className="section page-top">
      <div className="container">
        <div className="section-head">
          <p className="plus-eyebrow">{p.eyebrow}</p>
          <h1>{p.title}</h1>
          <p>{p.subtitle}</p>
        </div>

        <article className="content-panel">
          <h2>{p.whatTitle}</h2>
          <p>{p.what1}</p>
          <p>{p.what2}</p>
        </article>

        <div className="section-head" style={{ marginTop: '3rem' }}>
          <h2>{p.benefitsTitle}</h2>
          <p>{p.benefitsSubtitle}</p>
        </div>
        <div className="feature-grid">
          {p.benefits.map((item) => {
            const Icon = benefitIcons[item.icon] || Cloud;
            return (
              <article key={item.title} className="feature-tile tone-reports">
                <div className="feature-icon">
                  <Icon size={22} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </article>
            );
          })}
        </div>

        <div className="section-head" style={{ marginTop: '3rem' }}>
          <h2>{p.compareTitle}</h2>
          <p>{p.compareSubtitle}</p>
        </div>
        <div className="plus-compare">
          <article className="content-panel plus-compare-card">
            <div className="plus-compare-head">
              <CloudOff size={22} />
              <h3>{p.offline.title}</h3>
            </div>
            <ul>
              {p.offline.points.map((point) => (
                <li key={point}>
                  <CheckCircle2 size={16} />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </article>
          <article className="content-panel plus-compare-card featured">
            <div className="plus-compare-head">
              <Cloud size={22} />
              <h3>{p.online.title}</h3>
            </div>
            <ul>
              {p.online.points.map((point) => (
                <li key={point}>
                  <CheckCircle2 size={16} />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </article>
        </div>

        <div className="page-cta">
          <Link to="/demo" className="btn btn-primary btn-lg">
            {p.cta}
          </Link>
          <Link to="/features" className="btn btn-soft btn-lg">
            {t.nav.features}
          </Link>
        </div>
      </div>
    </section>
  );
}
